var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monaco-container"},[_c('div',{ref:"monacoContainer",staticClass:"monaco-editor",style:({ height: _vm.height + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }